import ReactDOM from 'react-dom/client';
import './global.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux"
import store from "./store/index"

const root = ReactDOM.createRoot(
          document.getElementById('root') as HTMLElement
);

root.render(
          <BrowserRouter>
                    <Provider store={store}>

                              <App />

                    </Provider>
          </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
